<template>
  <div>
    <b-form
      novalidate
      @submit.prevent="submit"
    >
      <validation-observer ref="formRef">
        <b-card>
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Name"
                rules="required"
              >
                <b-form-group
                  label="Name"
                  label-for="name"
                >
                  <b-form-input
                    id="name"
                    v-model="formData.name"
                    placeholder="Name"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Duration"
                rules="required"
              >
                <b-form-group
                  label="Duration"
                  label-for="duration"
                >
                  <b-form-input
                    id="duration"
                    v-model.number="formData.billingCycleDays"
                    type="number"
                    placeholder="Duration"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Price"
                rules="required"
              >
                <b-form-group
                  label="Price"
                  label-for="price"
                >
                  <b-form-input
                    id="price"
                    v-model.number="formData.price"
                    type="number"
                    placeholder="Price"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group label="Is Active">
                <b-form-checkbox
                  v-model="formData.isActive"
                  switch
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Description"
                rules="required"
              >
                <b-form-group
                  label="Description "
                  label-for="description"
                >
                  <b-form-textarea
                    id="description"
                    v-model="formData.description"
                    placeholder="Description"
                  />
                  <span class="text-danger"> {{ errors[0] }} </span>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Target"
              >
                <v-select
                  v-model="formData.target"
                  :clearable="false"
                  :options="TARGETS"
                  :reduce="(val) => val.key"
                />
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group label="Benefits">
                <b-button
                  variant="success"
                  size="sm"
                  @click="addBenefit"
                >
                  + Add Benefit
                </b-button>

                <b-row
                  v-for="(item, index) in formData.features.benefits"
                  :key="index"
                  class="border p-2 mt-2"
                >
                  <b-col
                    md="12"
                    class="d-flex justify-content-between mb-1"
                  >

                    <span>Name</span>
                    <b-button
                      variant="danger"
                      size="sm"
                      @click="removeBenefit(index)"
                    >
                      Remove Benefit
                    </b-button>
                  </b-col>
                  <b-col md="6">
                    <validation-provider
                      #default="{ errors }"
                      name="English Name"
                      rules="required"
                    >
                      <b-form-input
                        v-model="item.name.en"
                        placeholder="English Name"
                      />
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </validation-provider>
                  </b-col>
                  <b-col md="6">
                    <validation-provider
                      #default="{ errors }"
                      name="Arabic Name"
                      rules="required"
                    >
                      <b-form-input
                        v-model="item.name.ar"
                        placeholder="Arabic Name"
                      />
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </validation-provider>
                  </b-col>

                  <b-col md="12 my-1">
                    <span>Description</span>

                  </b-col>

                  <b-col md="6">
                    <validation-provider
                      #default="{ errors }"
                      name="English Description"
                      rules="required"
                    >
                      <b-form-textarea
                        v-model="item.description.en"
                        placeholder="English Description"
                      />
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </validation-provider>

                  </b-col>
                  <b-col md="6">
                    <validation-provider
                      #default="{ errors }"
                      name="Arabic Description"
                      rules="required"
                    >
                      <b-form-textarea
                        v-model="item.description.ar"
                        placeholder="Arabic Description"
                      />
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </validation-provider>
                  </b-col>

                  <b-col md="12 my-1">
                    <span>Note</span>

                  </b-col>

                  <b-col md="6">
                    <b-form-textarea
                      v-model="item.note.en"
                      placeholder="English Note (Optional)"
                    />

                  </b-col>
                  <b-col md="6">
                    <b-form-textarea
                      v-model="item.note.ar"
                      placeholder="Arabic Note (Optional)"
                    />

                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
            <b-col
              md="12"
              class="d-flex align-items-center justify-content-center"
            >
              <b-button
                block
                variant="primary"
                type="submit"
                :disabled="submitting"
              >
                <b-spinner
                  v-if="submitting"
                  small
                />
                <span v-else>Save</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </validation-observer>
    </b-form>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BRow,
  BCol,
  BSpinner,
  BFormTextarea,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import axiosIns from '@/libs/axios'
import { successNotification } from '@/utils/toast-notifications'

const TARGETS = [
  { label: 'Drivers', key: 'driver' },
  { label: 'Riders', key: 'rider' },
]
export default {
  components: {
    BCard,
    BForm,
    BFormInput,
    BSpinner,
    ValidationProvider,
    vSelect,
    BButton,
    ValidationObserver,
    BFormGroup,
    BRow,
    BCol,
    BFormCheckbox,
    BFormTextarea,
  },
  setup(_, ctx) {
    const userData = JSON.parse(localStorage.getItem('userData'))
    const userCountry = userData?.country || 'JO'
    const formData = ref({
      name: '',
      description: '',
      billingCycleDays: null,
      price: null,
      isActive: false,
      features: {
        benefits: [],
      },
      target: 'driver',
      country: userCountry.toLowerCase(),
    })
    const submitting = ref(false)
    const formRef = ref(null)

    const submit = async () => {
      try {
        submitting.value = true
        const res = await formRef.value.validate()
        if (!res) return
        await axiosIns.post('/subscription-plans', {
          plan: formData.value,
        })
        ctx.root.$router.push('/subscription-plans')
        successNotification('Created successfully')
      } finally {
        submitting.value = false
      }
    }

    const addBenefit = () => {
      formData.value.features.benefits.push({
        name: { en: '', ar: '' },
        description: { en: '', ar: '' },
        note: { en: '', ar: '' },

      })
    }

    const removeBenefit = index => {
      formData.value.features.benefits.splice(index, 1)
    }

    return {
      addBenefit,
      removeBenefit,
      submit,
      submitting,
      formRef,
      TARGETS,
      required,
      formData,
    }
  },
}
</script>

  <style>

  </style>
